import style from './PartnersBanner.module.css'
import Marquee from 'react-fast-marquee'

import gcpLogo from '../../../assets/images/gcp.png'
import vinnovaLogo from '../../../assets/images/vinnova.png'

const PartnersBanner = () => {
  return (
    <div className={style.container}>
      <Marquee autoFill pauseOnHover>
        <div className={`${style.item} ${style.partner}`}>DesignWorks</div>

        <div className={`${style.item} ${style.logo} ${style.logoVinnova}`}>
          <img
            src={vinnovaLogo}
            alt="Vinnova"
            className={style.logoImg}
            loading="lazy"
            draggable="false"
          />
        </div>

        <div className={`${style.item} ${style.partner}`}>almi</div>

        <div className={`${style.item} ${style.logo} ${style.logoGcp}`}>
          <img
            src={gcpLogo}
            alt="Google Cloud Platform"
            className={style.logoImg}
            loading="lazy"
            draggable="false"
          />
        </div>
      </Marquee>
    </div>
  )
}

export default PartnersBanner
